import { useUserStore } from '~/modules/user/stores/userStore';
import { useUser } from '~/modules/user/uses/useUser';
import { useAuthStore } from '~/modules/auth/stores/authStore';
import { CABINET_URL } from '~/constants/site/cabinet';

export default defineNuxtRouteMiddleware(async (to, from) => {
  const authStore = useAuthStore();
  const userStore = useUserStore();
  const user = useUser();
  const isTablet = useState<boolean>('isTablet');

  if (to.path.includes(CABINET_URL)) {
    const isAuthRoute = to.name === 'auth';

    if (!authStore.isUserAuthorized) {
      if (isAuthRoute) {
        if (!isTablet.value) {
          return navigateTo('/', { redirectCode: 401 });
        }

        return;
      }

      if (isTablet.value) {
        return navigateTo('/cabinet/auth', { redirectCode: 401 });
      }

      return navigateTo('/', { redirectCode: 401 });
    }

    if (isAuthRoute) {
      return navigateTo('/cabinet/');
    }

    if (!userStore.userData.email) {
      try {
        await user.setupUserData();
      } catch (e) {
        console.error(e);
      }
    }

    return;
  }
});
